<template>
  <div class="pl-5 pr-5">
    <p style="text-align: center; font-weight: 600; font-size: 18px;" class="mb-0 pt-4">{{text}}</p>
    <p>{{ $t(alternativeDeleteText) }}</p>
    <div class="row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4">
          <div class="col flex-grow pr-2">
              <Button :title="$t('Cancel')" buttonClass='cancel-button semi-bold w-100' @onClick="cancel"/>
          </div>
          <div class="col flex-grow pl-2">
              <Button :title="$t('Confirm')" buttonClass='save-button semi-bold w-100' @onClick="confirm"/>
          </div>
      </div>
  </div>
</template>

<script>
import Button from '@/components/Button'

export default {
    emits: ['confirm', 'cancel'],
    props: {
        text: {
            type: String,
            required: false,
            default: ''
        },
        alternativeDeleteText: {
            type: String,
            required: false,
            default: 'AreYouSureDelete'
        }
    },
    methods: {
        confirm(){
            this.$emit('confirm');
        },
        cancel(){
            this.$emit('cancel');
        }
    },
    components: {
        Button
    },
}
</script>



// WEBPACK FOOTER //
// src/components/QuestionConfirm.vue